import { HandleSize, isCovered } from "./index"
import { lockHeightComponent, lockWidthComponent } from "./tools"
/**
 *递归的 对组件进行覆盖检测和拉开
 * @param {Array} component 所需检查的组件数组
 * @param {String} basePath component中的元素指向到具体配置项的路径
 * @param {Number} wrapperSize 容器大小
 * @param {String} mode 模式 横轴检测为“x”,纵轴检测为“y”
 * @param {Boolean} resize 模式 当覆盖检测拉开时 如果会超出父容器 此时是否改变父容器大小
 * @param {Object} tools 工具函数 用于返回组件真实大小，某些情况下组件的大小可能是百分比
 *
 */
export function resetCoveredComponent({
  component,
  basePath,
  wrapperW,
  wrapperH,
  mode,
  resize,
  tools = new HandleSize(wrapperW, wrapperH)
}) {
  const positionTag = mode === "x" ? "left" : "top"
  const sizeTag = mode === "x" ? "width" : "height"
  const getPosition = opt => opt[positionTag]
  //是否出现了更改重叠组件left的操作 如果出现了，就递归检查组件碰撞情况
  let isMoved = false
  for (let i = 0; i < component.length; i++) {
    const opt1 = basePath ? component[i][basePath] : component[i]
    if(opt1.isQuickSite){
      continue
    }
    for (let j = i + 1; j < component.length; j++) {
      const opt2 = basePath ? component[j][basePath] : component[j]
      //判断是否重叠
      if (isCovered(opt1, opt2, tools)) {
        //是不是opt1在前面
        const opt1First = getPosition(opt1) < getPosition(opt2)
        //重叠大小
        const coveredSize = opt1First
          ? getPosition(opt1) + tools.getRealSize(opt1, sizeTag) - getPosition(opt2)
          : getPosition(opt2) + tools.getRealSize(opt2, sizeTag) - getPosition(opt1)
        //展开重叠组件后 被展开组件的终止x坐标
        const endPosition =
          (opt1First
            ? getPosition(opt2) + tools.getRealSize(opt2, sizeTag)
            : getPosition(opt1) + tools.getRealSize(opt1, sizeTag)) + coveredSize
        const wrapperSize = mode === "x" ? wrapperW : wrapperH //容器大小
        if (endPosition >= wrapperSize) {
          if (resize) {
            if (mode === "x") {
              wrapperW = endPosition
            } else {
              wrapperH = endPosition
            }
          } else if (
            Math.min(coveredSize / tools.getRealSize(opt2, sizeTag), coveredSize / tools.getRealSize(opt1, sizeTag)) <=
            0.3
          ) {
            //↑如果超出容器部分的占比 小于两个相互碰撞组件任意一个的30%,则进行组件缩小动作
            //找出超出部分大小，对于自身大小占比最小的哪个组件
            const isFirstMin =
              coveredSize / tools.getRealSize(opt1, sizeTag) < coveredSize / tools.getRealSize(opt2, sizeTag)
            const isLock = innerElement =>
              sizeTag === "width" ? lockWidthComponent(innerElement) : lockHeightComponent(innerElement)
            let isChange = false
            if (isFirstMin && !isLock(opt1.innerElement)) {
              isChange = true
              opt1[sizeTag] = tools.backUnit(opt1, tools.getRealSize(opt1, sizeTag) - coveredSize, sizeTag)
            } else if (!isLock(opt1.innerElement)) {
              isChange = true
              opt2[sizeTag] = tools.backUnit(opt2, tools.getRealSize(opt2, sizeTag) - coveredSize, sizeTag)
              opt2[positionTag] += coveredSize
            }
            if (isChange) isMoved = true
            continue
          } else continue
        }
        isMoved = true
        if (opt1First) {
          opt2[positionTag] += coveredSize
        } else {
          opt1[positionTag] += coveredSize
        }
      }
    }
  }
  if (isMoved) {
    return resetCoveredComponent({ component, basePath, wrapperW, wrapperH, mode, resize, tools })
  } else return mode === "x" ? wrapperW : wrapperH
}
